import { render, staticRenderFns } from "./FormPart.vue?vue&type=template&id=31c4224d&scoped=true&"
import script from "./FormPart.vue?vue&type=script&lang=js&"
export * from "./FormPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c4224d",
  null
  
)

export default component.exports